import { bl_fi_budget_item_RowClass } from '../../../dbschema/bl_fi_budget_item.model';
import { BaseContainerModel } from '../../base-container.model';


export class BudgetItemContainerModel extends BaseContainerModel {
    bl_fi_budget_item: bl_fi_budget_item_RowClass = new bl_fi_budget_item_RowClass();
}
